/**
 * Main menu
 */
const jobsSearch = () => {

  window.addEventListener('load', () => {
    const jobsSearch = document.querySelector('.searchwp-live-search-results');
    if(jobsSearch){
      jobsSearch.addEventListener('keydown', (e) => {
        if('ArrowDown' === e.key || 'ArrowUp' === e.key){
          e.preventDefault();
        }
      })
    }
  });

}

export default jobsSearch;
